// extracted by mini-css-extract-plugin
export default {"scaleBar":"scale_scaleBar__D8eG4","selected":"scale_selected__f3fvi","labels":"scale_labels__2Cp4C"};